<script>
    export default {
        name: 'modalPendingOrders',

        data() {
          return {
              orders: [],
          }
        },

        methods: {
            accessPendingOrders() {
                const ordersId = this.ordersToString()

                window.location = API_URL + '/meus-pedidos/pedidos/limpar-notificacoes' + ordersId
            },

            ordersToString() {
                const orders = this.orders,

                reducer = (prev, cur) => {
                    const symbol = prev == '' ? '?' : '&'

                    return prev + symbol + 'orders_id[]=' + cur.id
                }

                const urlString = orders.reduce(reducer, '')

                return urlString
            },

            async getNotViewOrders() {
                const response =  await this.axios.get(API_URL + '/meus-pedidos/pedidos/aguardando-visualizacao', {})
                const orders   = response.data.data

                this.orders = orders
            },

            async showPendingOrders() {
                try {
                    if (!this.orders.length) {
                        return
                    }

                    let text = ''

                    this.orders.forEach((order) => {
                        text += ` O protocolo <u>${order.id}</u> está em suas pendências.</br>`
                    })

                    this.$fire({
                        html: text,
                        type: "info",
                        confirmButtonText: "Clique aqui para verificar",
                        showCloseButton: true,
                        allowOutsideClick: false,
                        icon: undefined,
                    }).then(result => {
                        if (result.dismiss) {
                            return
                        }

                        if (result.value) {
                            this.accessPendingOrders()
                        }
                    });

                } catch (error) {
                    console.log(error)
                }
            }
        },

        async mounted() {
            await this.getNotViewOrders()
            this.showPendingOrders()
        }
    }
</script>

